import { CommonModule } from '@angular/common'
import { Component, HostListener, Input, inject } from '@angular/core'
import { NgSelectModule } from '@ng-select/ng-select'
import { Observable } from 'rxjs'
import { AutocompleteSelectComponent } from '../../../shared/ui/autocomplete-select/autocomplete-select.component'
import { GeomapDomainService } from '../../domain/geomap.domain'
import { ToolEnum } from '../../model/tool.enum'

@Component({
  selector: 'app-control-panel',
  standalone: true,
  imports: [CommonModule, NgSelectModule, AutocompleteSelectComponent],
  templateUrl: './control-panel.component.html',
  styleUrls: ['./control-panel.component.scss'],
})
export class ControlPanelComponent {
  @Input() isRaccordementTabActive = false
  @Input() isModeValorisationTabActive = false

  private readonly geomapDomainService = inject(GeomapDomainService)

  activeZoneId$: Observable<number> = this.geomapDomainService.activeZoneId$
  activeTool$: Observable<ToolEnum> = this.geomapDomainService.activeTool$
  selectedModeValorisation$: Observable<boolean> = this.geomapDomainService.selectedModeValorisation$
  selectedTypePoseCurrentZone$: Observable<boolean> = this.geomapDomainService.selectedTypePoseCurrentZone$
  selectedOutils$: Observable<boolean> = this.geomapDomainService.selectedOutils$
  selectedDessinOutilsSeulementZone$: Observable<boolean> = this.geomapDomainService.selectedDessinOutilsSeulementZone$
  isEnedisEnabled$: Observable<boolean> = this.geomapDomainService.isEnedisEnabled$
  isHtaEnabled$: Observable<boolean> = this.geomapDomainService.isHtaEnabled$
  isPostesEnabled$: Observable<boolean> = this.geomapDomainService.isPostesEnabled$
  trenchSelectionMode$: Observable<'private' | 'public' | 'ptr' | null> = this.geomapDomainService.trenchSelectionMode$
  validatedTrenchMode$: Observable<'private' | 'public' | 'ptr' | null> = this.geomapDomainService.validatedTrenchMode$
  isCadastreEnabled$: Observable<boolean> = this.geomapDomainService.isCadastreEnabled$;
  toolEnum = ToolEnum
  showNetworkTools = false

  shouldShowTrenchTools(mode: 'all' | 'restricted'): boolean {
    const selectionMode = this.geomapDomainService.state.value.trenchSelectionMode
    const validatedMode = this.geomapDomainService.state.value.validatedTrenchMode
    const isActive = this.isRaccordementTabActive && (!!selectionMode || !!validatedMode)
    if (!isActive) {
      return false
    }
    if (mode === 'restricted') {
      return validatedMode !== 'public'
    }
    return true
  }

  toggleCadastreMode(): void {
    this.geomapDomainService.toggleCadastreMode();
  }

  activateMeasureDistanceToolGeneric(): void {
    this.geomapDomainService.activateMeasureDistanceToolGeneric();
  }

  toggleEnedisMode(): void {
    this.geomapDomainService.toggleEnedisMode()
  }

  toggleHtaMode(): void {
    this.geomapDomainService.toggleHtaMode()
  }

  togglePostesMode(): void {
    this.geomapDomainService.togglePostesMode()
  }

  disableTools(): void {
    this.geomapDomainService.disableTools()
  }

  activateMeasureAreaTool(): void {
    this.geomapDomainService.activateMeasureAreaTool()
  }

  @HostListener('document:keyup.esc')
  resetUnfinishedDrawing(): void {
    this.geomapDomainService.resetUnfinishedDrawing()
  }

  activateMeasureAzimuthTool(): void {
    this.geomapDomainService.activateMeasureAzimuthTool()
  }

  activateMeasureDistanceTool(): void {
    this.geomapDomainService.activateMeasureDistanceTool()
  }

  activateEnedisDistanceTool(): void {
    this.geomapDomainService.activateEnedisDistanceTool()
  }

  activatePrivateTrenchEnrobeeTool(): void {
    this.geomapDomainService.activatePrivateTrenchEnrobeeTool()
  }

  activatePrivateTrenchNaturelTool(): void {
    this.geomapDomainService.activatePrivateTrenchNaturelTool()
  }

  activatePrivateTrenchToitureTool(): void {
    this.geomapDomainService.activatePrivateTrenchToitureTool()
  }

  activateRaccordementSquareTool(): void {
    this.geomapDomainService.activateRaccordementSquareTool()
  }

  activateDeleteTool(): void {
    this.geomapDomainService.activateDeleteTool()
  }

  activateExclusionTool(): void {
    this.geomapDomainService.activateExclusionTool()
  }

  resetCurrentZone(): void {
    this.geomapDomainService.resetCurrentZone()
  }

  resetDessinRaccordement(): void {
    this.geomapDomainService.resetDessinRaccordement()
  }

  resetDessinModeValorisation(): void {
    this.geomapDomainService.resetDessinModeValorisation()
  }

  toggleNetworkTools(): void {
    this.showNetworkTools = !this.showNetworkTools
  }
}
